$(document).ready(function() {
  let sliderWrapper = $(".valueProps__list--slider"),
      slidesPossitions = [],
      oldIndex = 0,
      closestIndex = 0,
      progressBar = $('.valueProps__barProgress');

  if (window.innerWidth >= 769) {
    sliderWrapper.on('init', function(event, slick){
      for (let i = 0; i < slick.slideCount; i++) {
        slidesPossitions.push((100 / slick.slideCount * i));
      }

      $.jScrollability([
        {
          'selector': '.valueProps',
          'start': function($el) { return $el.offset().top + window.innerHeight },
          'end': function($el) { return $el.offset().top + $el.height() },
          'fn': function($el,pcnt) {
            closestIndex = slidesPossitions.indexOf(slidesPossitions.reduce(function(prev, curr) {
              return (Math.abs(curr - pcnt * 100) < Math.abs(prev - pcnt * 100) ? curr : prev);
            }));

            if (oldIndex != closestIndex) {
              oldIndex = closestIndex;
              sliderWrapper.slick('slickGoTo', closestIndex,  true);
            }

            progressBar.height(`${pcnt * 100}%`);
          }
        }
      ]);
    });
  } else {
    $('.valueProps__list--slider').on('init', function (event, slick) {
      changeProgressBar(slick, 0);
    });

    $('.valueProps__list--slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      changeProgressBar(slick, nextSlide);
    });

    function changeProgressBar(slick, nextSlide) {
      let calc = ((nextSlide + 1) / (slick.slideCount - 1)) * 100;

      if(window.innerWidth <= 768) {
        calc = ((nextSlide + 1) / (slick.slideCount)) * 100;
      }

      progressBar.css({'width': `${calc}%`});
    }
  }

  sliderWrapper.slick({
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    speed: 500,
    cssEase: 'linear'
  });
});
